import { uploadJson } from 'services/api';
import { deleteInternalInfo } from 'utils/deleteInternalInfo';
import { UploadProjectFlowArg } from '../models';

export async function uploadJsonToProject(arg: UploadProjectFlowArg): Promise<void> {
  const { rootDocumentId, projectAssets } = arg;

  const { data: projectFileDocument } = await uploadJson(
    rootDocumentId,
    deleteInternalInfo(projectAssets),
  );
  projectAssets.documents[projectFileDocument.id] = projectFileDocument;
}
